export default __webpack_public_path__ + "static/logoCampana-39964ab9297438c272ee4d27bb7f56a7.png";